import React from 'react';
import { Line, Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, ArcElement, Title, Tooltip, Legend, Filler } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, ArcElement, Title, Tooltip, Legend, Filler);

const trafficData = {
  labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  datasets: [
    { label: 'Page Views', data: [42000, 58000, 51000, 67000, 72000, 88000, 95000, 84000, 102000, 96000, 115000, 108000], borderColor: '#4e73df', backgroundColor: 'rgba(78,115,223,0.08)', fill: true, tension: 0.4, pointRadius: 3 },
    { label: 'Unique Visitors', data: [18000, 24000, 21000, 29000, 31000, 38000, 42000, 37000, 45000, 42000, 51000, 48000], borderColor: '#1cc88a', backgroundColor: 'rgba(28,200,138,0.08)', fill: true, tension: 0.4, pointRadius: 3 },
  ],
};

const sourceData = {
  labels: ['Organic Search', 'Direct', 'Social Media', 'Referral', 'Email'],
  datasets: [{
    data: [42, 23, 18, 10, 7],
    backgroundColor: ['#4e73df', '#1cc88a', '#f6c23e', '#e74a3b', '#6f42c1'],
    borderWidth: 0,
    hoverOffset: 6,
  }],
};

const topPages = [
  { page: '/dashboard',  views: '48,291', bounce: '32%', duration: '3m 12s' },
  { page: '/users',      views: '31,054', bounce: '41%', duration: '2m 48s' },
  { page: '/analytics',  views: '22,880', bounce: '28%', duration: '4m 05s' },
  { page: '/reports',    views: '18,443', bounce: '37%', duration: '2m 22s' },
  { page: '/settings',   views: '9,112',  bounce: '54%', duration: '1m 38s' },
];

export default function Analytics() {
  return (
    <div>
      {/* Stats */}
      <div className="stats-grid" style={{ marginBottom: 28 }}>
        {[
          { label: 'Page Views',        value: '108K',  change: '+14%', up: true,  accent: '#4e73df' },
          { label: 'Unique Visitors',   value: '48K',   change: '+9%',  up: true,  accent: '#1cc88a' },
          { label: 'Avg Session',       value: '2m 54s',change: '+0.3s',up: true,  accent: '#f6c23e' },
          { label: 'Bounce Rate',       value: '36.4%', change: '-2.1%',up: false, accent: '#e74a3b' },
        ].map((s) => (
          <div key={s.label} className="card" style={{ borderLeft: `4px solid ${s.accent}` }}>
            <div className="card-body py-3">
              <div className="card-title">{s.label}</div>
              <div className="stat-value">{s.value}</div>
              <div className={`stat-change ${s.up ? 'up' : 'down'}`}>{s.up ? '▲' : '▼'} {s.change} vs last month</div>
            </div>
          </div>
        ))}
      </div>

      {/* Charts */}
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 20, marginBottom: 28 }}>
        <div className="card">
          <div className="card-body">
            <p className="section-title">Traffic Overview</p>
            <Line data={trafficData} options={{ responsive: true, plugins: { legend: { position: 'top' } }, scales: { y: { beginAtZero: true } } }} />
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <p className="section-title">Traffic Sources</p>
            <Doughnut data={sourceData} options={{ responsive: true, plugins: { legend: { position: 'bottom' } }, cutout: '65%' }} />
          </div>
        </div>
      </div>

      {/* Top Pages */}
      <div className="card">
        <div className="card-body">
          <p className="section-title">Top Pages</p>
          <table className="dash-table">
            <thead>
              <tr>{['Page', 'Views', 'Bounce Rate', 'Avg Duration'].map((h) => <th key={h}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {topPages.map((row) => (
                <tr key={row.page}>
                  <td style={{ fontWeight: 600, fontFamily: 'monospace' }}>{row.page}</td>
                  <td>{row.views}</td>
                  <td style={{ color: parseFloat(row.bounce) > 45 ? '#e74a3b' : 'var(--text-primary)' }}>{row.bounce}</td>
                  <td style={{ color: 'var(--text-muted)' }}>{row.duration}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
